// O mesmo SPA/deploy serve os dois domínios -- console de gestão (admin.orbita...) e
// console do cliente (orbita...). A diferença é só qual nav/painel aparece; a segurança
// de verdade continua no backend (@PreAuthorize). Em localhost (dev) nada é restringido,
// pra dar pra testar os dois papéis na mesma máquina.
export const ADMIN_HOSTNAME = 'admin.orbita.smsmurilo.com.br'
export const CLIENT_HOSTNAME = 'app.orbita.smsmurilo.com.br'

export function isLocalDevHost(hostname: string = window.location.hostname): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1'
}

export function managementConsoleUrl(): string {
  return `https://${ADMIN_HOSTNAME}`
}
export function clientConsoleUrl(): string {
  return `https://${CLIENT_HOSTNAME}`
}

// true = pode exibir telas e dados de GESTÃO DA PLATAFORMA (agregado de todas as
// organizações). No console do cliente isso é sempre false, mesmo pra um admin.
export function isManagementConsole(hostname: string = window.location.hostname): boolean {
  return isLocalDevHost(hostname) || hostname === ADMIN_HOSTNAME
}
